import { render, staticRenderFns } from "./Hotkeys.vue?vue&type=template&id=20593c10&"
import script from "./Hotkeys.vue?vue&type=script&lang=js&"
export * from "./Hotkeys.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports